const AVAILABILITY_LABELS: Record<string, string> = {
  immediately: "Immediately",
  "2_weeks": "2 weeks ",
  "1_month": "1 month",
  "2_months": "2 months",
  "3_months": "3 months",
};

export const formatAvailability = (availability: string): string => {
  const normalizedAvailability = availability.trim();

  return (
    AVAILABILITY_LABELS[normalizedAvailability] ||
    normalizedAvailability
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, (character) => character.toUpperCase())
  );
};
